import React, { useState, useRef, useEffect } from 'react'
import Modal from './components/Modal'
import CookieBar from './components/CookieBar'
import LiteYouTubeEmbed from 'react-lite-youtube-embed'

//assets
import header_left from './assets/left-header.png'
import header_right from './assets/right-header.png'
import teeth from './assets/teeth.svg'
import teeth2 from './assets/teeth2.svg'
import swoosh from './assets/swoosh.svg'
import duurzaam from './assets/duurzame-toekomst.png'
import afwisseling from './assets/afwisseling.png'
import transitie from './assets/digitale-transitie.png'
import zorgsector from './assets/zorgsector.png'
import knmc from './assets/Logo-KNMC.png'
import anneessens from './assets/logo-anneessens-funck.svg'
import vesalius from './assets/logo-vesalius-instituut.png'
import syntra from './assets/logo-syntra.png'
import laptop from './assets/laptop.svg'
import tooth from './assets/tooth.svg'
import to_top from './assets/to-top.svg'
import onderwijskiezer from './assets/onderwijskiezer.png'
import vlaanderen from './assets/vlaanderen.png'
import footer_bg_desktop from './assets/footer-bg-desktop.png'
import footer_bg_mobile from './assets/footer-bg-mobile.png'

//styles
import './styles/App.scss'
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'

//sections
import BachelorEducation from './components/sections/BachelorEducation'

const App = () => {
	const [showModal, setShowModal] = useState(false)
	const [titleModal, setTitleModal] = useState('')
	const [contentModal, setContentModal] = useState('')
	const cookieTitle = 'Cookie Policy'
	const cookieTxt = 'Die dingen waar je wettelijk iets mee moet, maar wij liever bij de koffie geven. <strong>Functionele cookies</strong> Dit zijn cookies die noodzakelijk zijn om deze website te laten functioneren. Zonder deze functionele cookies werkt deze site niet optimaal. Volgens de cookiewet hoeft voor deze categorie cookies geen toestemming te worden gevraagd. <strong>Analytische cookies</strong> Deze site werkt met Google Analytics en gebruikt analytische cookies zodat we kunnen meten waar onze bezoekers vandaan komen, welk besturingssysteem ze gebruiken, hoeveel mensen bepaalde artikelen lezen etc. Deze informatie is voor ons van groot belang; op basis van deze meetgegevens kunnen we de site optimaliseren en gebruiksvriendelijker maken. De verzamelde gegevens worden niet voor een ander doel gebruikt of aan derden ter beschikking gesteld.  Cookies bevatten geen persoonsgegevens, UDB kan cookies daarom niet gebruiken om u te identificeren. We houden ons altijd aan de richtlijnen van de Autoriteit Persoonsgegevens. <strong>Cookies uitzetten</strong> Mocht je geen cookies willen installeren, dan kun je dit in je browser uitzetten. Raadpleeg daarvoor de helpfunctie en/of de instellingen van je browser: <a target="_blank" rel="noreferrer" href="https://support.google.com/chrome/answer/95647?hl=nl" title="Chrome">Chrome</a>, <a target="_blank" rel="noreferrer" href="https://support.microsoft.com/en-us/windows/delete-and-manage-cookies-168dab11-0753-043d-7c16-ede5947fc64d" title="Internet Explorer">Internet Explorer</a>, <a target="_blank" rel="noreferrer" href="https://support.mozilla.org/nl/kb/verbeterde-bescherming-tegen-volgen-firefox-desktop?redirectlocale=nl&redirectslug=cookies-in-en-uitschakelen-websites-voorkeuren" title="Firefox">Firefox</a> en <a target="_blank" rel="noreferrer" href="https://support.apple.com/nl-nl/guide/safari/sfri11471/mac" title="Safari">Safari</a>. Let op! Als je deze cookies in je browser uitzet, kun je niet altijd van alle functionaliteiten van deze site gebruik maken.'
	const laboTxt = '<ul class="labo-list"><li>ATELIER TEETH &amp; ART (Schilde) <span>03 231 40 22</span></li><li>CAMERLYNCK TTL (Lovendegem) <span>09 222 82 83</span></li><li>DE CLERCQ DENTAL WORKS (Erembodegem) <span>053 77 27 98</span></li><li>DE GELDER DSS (Zele) <span>052 44 56 86</span></li><li>DENTAAL LABO GHYSENS (Affligem) <span>053 39 69 68</span></li><li>DENTAAL TEMA (Brugge) <span>050 31 68 38</span></li><li>DENTAL ART (Zottegem) <span>09 360 44 15</span></li><li>DENTAL LABO VANDERBEKEN (Oostende) <span>059 56 86 56</span></li><li>DPI (Anderlecht) <span>02 343 05 18</span></li><li>ELYSEE DENTAL (Herent) <span>016 27 00 40</span></li><li>EXCENT TANDTECHNIEK INTRADENT (Temse) <span>03 710 60 60</span></li><li>HEYNS DENTAL (Mol) <span>014 31 32 71</span></li><li>LABO DE WITTE (Lokeren) <span>09 348 26 60</span></li><li>LABO HOET &amp; CO (Gent) <span>09 225 25 08</span></li><li>LABO MASSA (Borgerhout) <span>03 235 95 72</span></li></ul>'
	const bottom = useRef(null)
	const toTop = useRef(null)

	const openModal = (e, title, content) => {
		e.preventDefault()
		setShowModal(true)
		setTitleModal(title)
		setContentModal(content)
	}

	const scrollToTop = (e) => {
		e.preventDefault()
		document.documentElement.scrollTo({ top: 0, behavior: 'smooth' })
	}

	const toggleToTop = () => {
		if (window.scrollY > 100) {
			toTop.current.style.opacity = 1
		} else {
			toTop.current.style.opacity = 0
		}
	}

	useEffect(() => {
		toggleToTop()
	}, [])

	window.onscroll = () => {
		toggleToTop()
	}

	return (
		<div className='app'>
			<header className='header'>
				<figure className='header__figure'>
					<img className='left image' src={header_left} alt="Tandtechnicus-student-vrouw" />
					<img className='right image' src={header_right} alt="Tandtechnicus-student-man" />
				</figure>
				<div className='header__body'>
					<strong>
						<p>Word een <span>TTT</span>&rsquo;er?</p>
					</strong>
					<h1>
						Een <span>T</span>oekomstige<br /> <span>T</span>and<span>T</span>echnicus
					</h1>
					<img src={teeth} className='header__icon desktop' alt='' />
					<img src={teeth2} className='header__icon mobile' alt='' />
					<img src={swoosh} className='header__swoosh' alt='' />
				</div>
			</header>

			<section className="content">
				<h2 className="content__title line-title"><span>Wat doet een</span><br /> <span>tandtechnicus?</span></h2>
				<p className='content__para'>Een perfect gebit en een stralende glimlach? Daar is een tand- of dentaaltechnicus medeverantwoordelijk voor. <strong>Deze specialist werkt in opdracht van een tandarts, orthodontist of een andere behandelaar en maakt tandheelkundige systemen</strong> zoals kronen, bruggen en kunstgebitten. Hij maakt hiervoor gebruik van manuele technieken en innovatieve digitale processen.</p>
			</section>

			<section className="video">
				<h2 className="video__title line-title"><span>Een blik achter</span><br /> <span>de schermen</span></h2>
				<div className="video__embed">
					<LiteYouTubeEmbed
						id="JHZc_NkJZj8"
						playlist={false}
						playlistCoverId="JHZc_NkJZj8"
						poster="maxresdefault"
						title="Word een TTT'er! Ontdek de b(l)oeiende toekomst van tandtechnicus"
						noCookie={true}
					/>
				</div>
			</section>

			<section className="articles">
				<h2 className="articles__title line-title"><span>Als TTT&apos;er kies</span><br /> <span>je voor...</span></h2>
			</section>

			<section className='article'>
				<figure className='article__figure'>
					<img src={duurzaam} className='article__img' alt='' />
				</figure>
				<div className='article__body'>
					<h2 className='article__title'>
						een <span>duurzame toekomst</span>
					</h2>
					<ul>
						<li>Ga direct aan de slag na de 3de graad of bereid je voor op een 7de specialisatiejaar</li>
						<li>Ontdek een brede algemene basiskennis wetenschappen voor je latere studiekeuze</li>
						<li>Ga voor een vroege en doelgerichte specialisatie met werkzekerheid</li>
					</ul>
				</div>
				<blockquote className='article__quote'>
					<p>
						&quot;verantwoordelijkheid en het helpen van mensen vind ik het meest belangrijke.&quot;
					</p>
					<cite>
						Student Tandtechniek
						<span><a id="testimonial-knmc" target="_blank" rel="noreferrer" href="https://knmc.be/stem-wetenschappen-graad3/#1641943153358-10" title="KNMC">KNMC - Merksem</a></span>
					</cite>
				</blockquote>
			</section>

			<section className='article'>
				<figure className='article__figure'>
					<img src={afwisseling} className='article__img' alt='' />
				</figure>
				<div className='article__body'>
					<h2 className='article__title'>
						een job met <span>afwisseling!</span>
					</h2>
					<ul>
						<li>Werk met je handen en ontwerp op computer</li>
						<li>Verdiep je in de kleinste technische details en volg totaalprojecten van A tot Z</li>
						<li>Wissel af tussen of combineer digitale en manuele taken</li>
					</ul>
				</div>
				<blockquote className='article__quote'>
					<p>
						&quot;Als beroep dacht ik altijd aan tandarts. Maar met de studie tandtechnieken heb ik echt iets gevonden waar ik ook nog mijn perfectionisme en creativiteit kwijt kan.&quot;
					</p>
					<cite>
						Student Tandtechniek
						<span><a id="testimonial-anneessensfunck" target="_blank" rel="noreferrer" href="https://sites.google.com/view/anneessens/studierichtingen/df-tso/56-df-dt" title="Hoofdstedelijk Instituut Anneessens-Funck">Hoofdstedelijk Instituut Anneessens-Funck - Brussel</a></span>
					</cite>
				</blockquote>
			</section>

			<section className='article'>
				<figure className='article__figure'>
					<img src={transitie} className='article__img' alt='' />
				</figure>
				<div className='article__body'>
					<h2 className='article__title'>
						een sector in volle <span>digitale transitie</span>
					</h2>
					<ul>
						<li>Ontdek 3D scannen en 3D printen als belangrijk productieproces van morgen</li>
						<li>Kies dagelijks uit talloze nieuwe materialen en toekomstgerichte technieken</li>
						<li>Optimaliseer je eindresultaat door combinatie van digitale en analoge technologie</li>
					</ul>
				</div>
				<blockquote className='article__quote'>
					<p>
						&quot;Met de laatste nieuwe digitale technieken is je eindresultaat nog veel mooier, beter en sterker. Daar geniet ik echt van.&quot;
					</p>
					<cite>
						Student Tandtechniek
						<span><a id="testimonial-vesalius" target="_blank" rel="noreferrer" href="https://www.vesaliusinstituut.be/nl/aanbod/3de-graad/dentaaltechnieken" title="Vesaliusinstituut">Vesaliusinstituut - Oostende</a></span>
					</cite>
				</blockquote>
			</section>

			<section className='article'>
				<figure className='article__figure'>
					<img src={zorgsector} className='article__img' alt='' />
				</figure>
				<div className='article__body'>
					<h2 className='article__title'>
						De <span>zorgsector</span> van morgen
					</h2>
					<ul>
						<li>Help patiënten met zelf bedachte en gerealiseerde totaaloplossingen</li>
						<li>Bespreek technische en esthetische uitdagingen met tandartsen</li>
						<li>Maak deel uit van een patiëntgericht team specialisten</li>
					</ul>
				</div>
				<blockquote className='article__quote'>
					<p>
						&quot;De gedachte om mensen terug n&rsquo;n grote en moooie smile te geven. Er is toch niets leuker dan dat!&quot;
					</p>
					<cite>
						Student Tandtechniek
						<span><a id="testimonial-syntra" target="_blank" rel="noreferrer" href="https://www.syntra-limburg.be/opleidingen/leertijd-tandprothesetechnicus" title="Syntra">Syntra - Hasselt</a></span>
					</cite>
				</blockquote>
			</section>

			<section className='section section--breaker'>
				<div className='section__header'>
					<img
						src={laptop}
						className='section__header__icon'
						alt=''
						aria-hidden='true'
					/>
					<h2 className='section__title'>Kies een school</h2>
				</div>
				<div className='section__body'>
					<div className='card__wrapper'>
						<ul className='card__list'>
							<li>
								<div className="content">
									<p>Voltijds studeren</p>
									<p>De richting tandtechnieken start in de 3de graad TSO. Nadien kan je meteen aan de slag of kies je voor een 7de specialisatiejaar (Se-n-Se). Neem contact op met één van de onderstaande  scholen voor meer informatie en inschrijving. Tot snel!</p>
									<p>voor jongeren van 15 tot 25 jaar.</p>
								</div>
							</li>

							<li>
								<a id="school-knmc" target="_blank" rel="noreferrer" href="https://knmc.be/stem-wetenschappen-graad3/#1641943153358-10" title="KNMC" className='card'>
									<span className='card__sup'>Antwerpen</span>
									<figure className='card__figure'>
										<img src={knmc} className='card__img' alt='' />
									</figure>
									<div className='card__body'>
										<h3 className='card__title'>KNMC</h3>
										<span className='card__subtitle'>
											Merksem <span>(Antwerpen)</span>
										</span>
									</div>
									<div className='card__footer'>
										<span className='btn btn--arrow'>Bekijk ons studieprogramma</span>
									</div>
								</a>
							</li>

							<li>
								<a id="school-anneessensfunck" target="_blank" rel="noreferrer" href="https://sites.google.com/view/anneessens/studierichtingen/df-tso/56-df-dt" title="Hoofdstedelijk Instituut Anneessens-Funck" className='card'>
									<span className='card__sup'>Vlaams-Brabant</span>
									<figure className='card__figure'>
										<img src={anneessens} className='card__img' alt='' />
									</figure>
									<div className='card__body'>
										<h3 className='card__title'>
											Hoofdstedelijk instituut<br /> anneessens funck
										</h3>
										<span className='card__subtitle'>
											Brussel <span>(Vlaams-Brabant)</span>
										</span>
									</div>
									<div className='card__footer'>
										<span className='btn btn--arrow'>Bekijk ons studieprogramma</span>
									</div>
								</a>
							</li>

							<li>
								<a id="school-vesalius" target="_blank" rel="noreferrer" href="https://www.vesaliusinstituut.be/nl/aanbod/3de-graad/dentaaltechnieken" title="Vesaliusinstituut" className='card'>
									<span className='card__sup'>West-Vlaanderen</span>
									<figure className='card__figure'>
										<img src={vesalius} className='card__img' alt='' />
									</figure>
									<div className='card__body'>
										<h3 className='card__title'>Vesaliusinstituut</h3>
										<span className='card__subtitle'>
											Oostende <span>(West-Vlaanderen)</span>
										</span>
									</div>
									<div className='card__footer'>
										<span className='btn btn--arrow'>Bekijk ons studieprogramma</span>
									</div>
								</a>
							</li>
						</ul>
						<ul className='card__list'>
							<li>
								<div className="content">
									<p>Leren ÉN werken combineren?</p>
									<p>Kies dan voor de 2-jarige opleiding dentaaltechnisch helper, duaal leren in SYNTRA Hasselt. Contacteer de school voor meer informatie.</p>
									<p>voor jongeren van 15 tot 25 jaar.</p>
								</div>
							</li>

							<li>
								<a id="school-syntra" target="_blank" rel="noreferrer" href="https://www.syntrapxl.be/" title="Syntra" className='card'>
									<span className='card__sup'>Limburg</span>
									<figure className='card__figure'>
										<img src={syntra} className='card__img' alt='' />
									</figure>
									<div className='card__body'>
										<h3 className='card__title'>Syntra (Duaal leren)</h3>
										<span className='card__subtitle'>
											Hasselt <span>(Limburg)</span>
										</span>
										<span className="card__extra">vanaf 1 september 2025</span>
									</div>
									<div className='card__footer'>
										<span className='btn btn--arrow'>vanaf 1 september 2025</span>
									</div>
								</a>
							</li>

							<li>
								<div className="content">
									<h3>Een handig overzicht van het aanbod?</h3>
									<p>Je kan deze opleiding ook volgen in volwassenonderwijs. Ontdek het volledige aanbod. </p>
									<a id="download-pdf" target='_blank' href="Opleidingen_tandtechnieken_overzicht_2024.pdf" className='btn'>DOWNLOAD PDF</a>
								</div>
							</li>
						</ul>
					</div>
				</div>

				<img
					src={tooth}
					className='section--breaker__bg'
					alt=''
					aria-hidden='true'
				/>
			</section>
			
			<BachelorEducation />

			<section className='labo'>
				<div className='labo__container'>
					<div className="labo__columns">
						<div className="labo__column">
							<h3 className='line-title'>
								<span>Laat je overtuigen!</span>
							</h3>
							<p>Met een bezoek aan een van onze labo&apos;s</p>
							<button id="open-labo" className='btn' onClick={e => openModal(e, 'Labo Popup', laboTxt)}>Ontdek ze hier</button>
						</div>
					</div>
				</div>
			</section>

			<footer className='footer'>
				<div className='footer__top' ref={bottom}>
					<div className='footer__top__left'>
						<ul className='logo-list'>
							<li>
								<a id="footer-onderwijskiezer" target="_blank" rel="noreferrer" href='https://www.onderwijskiezer.be/v2/secundair/sec_detail.php?detail=227' className='logo-list__item'>
									<img src={onderwijskiezer} className='logo-list__item__img' alt='' />
								</a>
							</li>
							<li>
								<a id="footer-vlaanderen" target="_blank" rel="noreferrer" href='https://onderwijs.vlaanderen.be/nl' className='logo-list__item'>
									<img src={vlaanderen} className='logo-list__item__img' alt='' />
								</a>
							</li>
						</ul>
					</div>
					<div className='footer__top__right'>
						<img
							src={footer_bg_desktop}
							className='footer__bg footer__bg--desktop'
							alt=''
						/>
						<img
							src={footer_bg_mobile}
							className='footer__bg footer__bg--mobile'
							alt=''
						/>
					</div>
				</div>
				<button id="back-top" onClick={e => scrollToTop(e)} className='to-top' ref={toTop}>
					<img src={to_top} className='top-top__img' alt='Terug naar boven' />
				</button>
				<div className='footer__bottom'>
					<button id="back-top-mobile" onClick={e => scrollToTop(e)} className='to-top mobile'>
						<img src={to_top} className='top-top__img' alt='Terug naar boven' />
					</button>
					<ul>
						<li>
							<a id="footer-udb" target="_blank" rel="noreferrer" href='https://www.udb.be/'>UDB (Unie van Dentaaltechnische Bedrijven)</a>
						</li>
						<li>
							<a id="footer-knmc" target="_blank" rel="noreferrer" href='https://knmc.be/stem-wetenschappen-graad3/#1641943153358-10'>KNMC (Stella Maris Instituut)</a>
						</li>
						<li>
							<a id="footer-anneessensfunck" target="_blank" rel="noreferrer" href='https://sites.google.com/view/anneessens/studierichtingen/df-tso/56-df-dt'>Hoofdstedelijk Instituut Anneessens Funck</a>
						</li>
						<li>
							<a id="footer-vesalius" target="_blank" rel="noreferrer" href='https://www.vesaliusinstituut.be/nl/aanbod/3de-graad/dentaaltechnieken'>Vesaliusinstituut</a>
						</li>
						<li>
							<a id="footer-syntra" target="_blank" rel="noreferrer" href='https://www.syntra-limburg.be/opleidingen/leertijd-tandprothesetechnicus'>Syntra Hasselt</a>
						</li>
					</ul>
					<ul>
						<li>
							<button id="opencookie" onClick={e => openModal(e, cookieTitle, cookieTxt)}>Cookie Policy</button>
						</li>
						{/* <li>
							<button onClick={e => openModal(e, 'Privcay Policy', '<strong>Sunt laborum</strong> sint pariatur deserunt deserunt magna consequat deserunt reprehenderit irure dolore veniam fugiat. <strong>Sunt laborum</strong> sint pariatur deserunt deserunt magna consequat deserunt reprehenderit irure dolore veniam fugiat. <strong>Sunt laborum</strong> sint pariatur deserunt deserunt magna <a href="#">consequat deserunt</a> reprehenderit irure dolore veniam fugiat. <strong>Sunt laborum</strong> sint pariatur deserunt deserunt magna consequat deserunt reprehenderit irure dolore veniam fugiat.  <strong>Sunt laborum</strong> sint pariatur deserunt deserunt magna consequat deserunt reprehenderit irure dolore veniam fugiat.  <strong>Sunt laborum</strong> sint pariatur deserunt deserunt magna consequat deserunt reprehenderit irure dolore veniam fugiat.')}>Privcay Policy</button>
						</li> */}
					</ul>
				</div>
			</footer>
			<CookieBar cookieTitle={cookieTitle} cookieTxt={cookieTxt} setTitleModal={setTitleModal} setContentModal={setContentModal} setShowModal={setShowModal} />
			<Modal show={showModal} setShow={setShowModal} title={titleModal} content={contentModal} />
		</div>
	)
}

export default App
